"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DialogSurfaceMotion", {
    enumerable: true,
    get: function() {
        return DialogSurfaceMotion;
    }
});
const _reactmotion = require("@fluentui/react-motion");
const _reacttheme = require("@fluentui/react-theme");
const keyframes = [
    {
        opacity: 0,
        boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.1)',
        transform: 'scale(0.85) translateZ(0)'
    },
    {
        boxShadow: _reacttheme.tokens.shadow64,
        transform: 'scale(1) translateZ(0)',
        opacity: 1
    }
];
const DialogSurfaceMotion = (0, _reactmotion.createPresenceComponent)({
    enter: {
        keyframes,
        easing: _reactmotion.motionTokens.curveDecelerateMid,
        duration: _reactmotion.motionTokens.durationGentle
    },
    exit: {
        keyframes: [
            ...keyframes
        ].reverse(),
        easing: _reactmotion.motionTokens.curveAccelerateMin,
        duration: _reactmotion.motionTokens.durationGentle
    }
});
